import { Pipe, PipeTransform } from '@angular/core';
import { IBillboardInfoData } from '../../interfaces';

@Pipe({ name: 'setBillboardInfo', standalone: true })
export class SetBillboardInfoPipe implements PipeTransform {
  transform(value: any, isNeedNumOfEmployees: boolean): IBillboardInfoData {
    return {
      id: value.id,
      avatar: value.avatar,
      name: value.name,
      description: {
        city: {
          name: value.city ? value.city.name : null,
        },
        house: value.house,
        phone: value.phone,
        email: value.email,
        description: value.description,
        numOfEmployees: isNeedNumOfEmployees ? value.numberOfEmployees : null,
      },
      isFavorite: value.isFavorite,
    };
  }
}
